import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase, ref, set, push, onValue, query, orderByKey, startAt, limitToLast } from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyCY9O6Zkq1B7HxYq-4ismNmocrG2ALyBSI",
    authDomain: "floppy-floods-ai.firebaseapp.com",
    projectId: "floppy-floods-ai",
    storageBucket: "floppy-floods-ai.firebasestorage.app",
    messagingSenderId: "344257590368",
    appId: "1:344257590368:web:c6784c0d4d0ee8d00abf05",
    databaseURL: "https://floppy-floods-ai-default-rtdb.firebaseio.com"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getDatabase(app);

// Data logging functions
export const saveSensorReading = async (data) => {
    const timestamp = Date.now();
    const reading = {
        timestamp,
        fecha: new Date().toISOString(),
        humedad_suelo: data.soilMoisture || 0,
        temperatura: data.temperature || 0,
        humedad_ambiente: data.humidity || 0,
        nivel_agua: data.waterLevel || 0
    };

    // Save history
    await set(ref(db, `lecturas/${timestamp}`), reading);
    // Save last reading
    await set(ref(db, 'ultima_lectura'), reading);
};

export const saveEvent = async (type, desc, data = {}) => {
    const timestamp = Date.now();
    await set(ref(db, `eventos/${timestamp}`), {
        timestamp,
        fecha: new Date().toISOString(),
        tipo: type,
        descripcion: desc,
        datos: data
    });
};
